import LegalPageLayout from '../../components/LegalPageLayout'

export default function FinancialServicesGuide() {
  return (
    <LegalPageLayout title="Financial Services Guide" lastUpdated="February 6, 2026">
      <div className="space-y-6">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
          <p className="text-sm text-gray-700">
            <strong>PLACEHOLDER DOCUMENT:</strong> This document contains placeholder legal text. 
            You must have this reviewed and customized by a qualified legal professional before going live. 
            This is not legal advice.
          </p>
        </div>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">About This Financial Services Guide</h2>
          <p className="text-gray-700 mb-4">
            This Financial Services Guide (FSG) provides you with important information about LoanLoop and 
            the services we provide. This FSG is designed to help you decide whether to use our services.
          </p>
          <p className="text-gray-700">
            This FSG includes information about:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-4">
            <li>Who we are and how to contact us</li>
            <li>The services we provide</li>
            <li>How we are remunerated</li>
            <li>Our complaints handling process</li>
            <li>Our dispute resolution procedures</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Who We Are</h2>
          <div className="bg-gray-50 p-4 rounded-md">
            <p className="text-gray-700"><strong>Business Name:</strong> LoanLoop</p>
            <p className="text-gray-700"><strong>ABN:</strong> [TBC - Your ABN]</p>
            <p className="text-gray-700"><strong>Australian Credit Licence (ACL):</strong> TBC - Not yet obtained</p>
            <p className="text-gray-700"><strong>Address:</strong> [Your Business Address]</p>
            <p className="text-gray-700"><strong>Email:</strong> contact@loanloop.com.au</p>
            <p className="text-gray-700"><strong>Phone:</strong> [Your Phone Number]</p>
          </div>
          
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-4">
            <p className="text-sm text-gray-700">
              <strong>Note:</strong> LoanLoop is currently operating as a comparison service only. 
              We do not currently hold an Australian Credit Licence and do not provide credit services, 
              credit assistance, or financial advice.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services We Provide</h2>
          <p className="text-gray-700 mb-4">
            <strong>LoanLoop provides comparison services only.</strong> Specifically:
          </p>
          
          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">What We Do:</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Display information about mortgage products from various lenders</li>
            <li>Provide comparison tools to help you compare loan options</li>
            <li>Offer calculators and educational resources</li>
            <li>Present publicly available interest rates and loan features</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">What We DO NOT Do:</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Provide credit or lending services</li>
            <li>Provide credit assistance or broker services</li>
            <li>Provide financial advice or recommendations</li>
            <li>Approve or process loan applications</li>
            <li>Act as an intermediary between you and lenders</li>
            <li>Receive or handle loan applications on behalf of lenders</li>
          </ul>

          <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mt-4">
            <p className="text-gray-700">
              <strong>Important:</strong> Our service is informational only. You deal directly with lenders 
              for all loan applications and credit services. We have no role in the lending process.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Remuneration and Fees</h2>
          
          <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1 User Fees</h3>
          <p className="text-gray-700 mb-4">
            <strong>LoanLoop does not charge users any fees</strong> for accessing our comparison service. 
            Our Website is free to use.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">3.2 How We Are Funded</h3>
          <p className="text-gray-700 mb-4">
            LoanLoop may receive remuneration from:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Advertising fees from lenders who advertise on our platform</li>
            <li>Referral fees if you click through to a lender's website (where applicable)</li>
            <li>Sponsorship arrangements with financial institutions</li>
          </ul>
          <p className="text-gray-700 mt-4">
            <strong>Important:</strong> Any remuneration we receive does not affect the information we display. 
            We strive to present accurate, unbiased comparison information regardless of commercial relationships.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">3.3 Lender Fees</h3>
          <p className="text-gray-700">
            Please note that lenders may charge their own fees for loan products, including application fees, 
            ongoing fees, and exit fees. These are outlined in each lender's product disclosure statement 
            and terms and conditions. LoanLoop does not receive any portion of lender fees.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Relationships and Associations</h2>
          <p className="text-gray-700 mb-4">
            LoanLoop may have commercial relationships with some lenders whose products are displayed 
            on our Website. These relationships may include:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Advertising agreements</li>
            <li>Referral arrangements</li>
            <li>Data licensing agreements</li>
          </ul>
          <p className="text-gray-700 mt-4">
            We aim to include a wide range of lenders, including those with whom we have no commercial relationship. 
            Our goal is to provide comprehensive comparison information to help you make informed decisions.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Important Information</h2>
          
          <h3 className="text-xl font-semibold text-gray-900 mb-3">5.1 Not Financial Advice</h3>
          <p className="text-gray-700 mb-4">
            <strong>The information we provide is general in nature and does not constitute financial advice.</strong>
          </p>
          <p className="text-gray-700">
            We do not consider your personal circumstances, objectives, or needs. Before making any decision, 
            you should seek independent advice from a licensed financial advisor or mortgage broker.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">5.2 Rates are Indicative</h3>
          <p className="text-gray-700">
            Interest rates and loan information displayed are indicative only and may vary based on your 
            circumstances. Lenders may change rates at any time. Always verify current rates directly with lenders.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">5.3 No Guarantee</h3>
          <p className="text-gray-700">
            We do not guarantee loan approvals, rate availability, or any outcomes from using our service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Privacy and Confidentiality</h2>
          <p className="text-gray-700 mb-4">
            We are committed to protecting your privacy. Information about how we collect, use, and disclose 
            your personal information is set out in our Privacy Policy.
          </p>
          <p className="text-gray-700">
            You can access our Privacy Policy at: <a href="/legal/privacy" className="text-primary-600 hover:text-primary-700 underline">Privacy Policy</a>
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Complaints and Dispute Resolution</h2>
          
          <h3 className="text-xl font-semibold text-gray-900 mb-3">7.1 Internal Complaints Process</h3>
          <p className="text-gray-700 mb-4">
            If you have a complaint about our service, we encourage you to contact us first. We are committed 
            to resolving complaints fairly and efficiently.
          </p>
          <p className="text-gray-700 mb-4">
            <strong>How to lodge a complaint:</strong>
          </p>
          <div className="bg-gray-50 p-4 rounded-md mb-4">
            <p className="text-gray-700"><strong>Email:</strong> complaints@loanloop.com.au</p>
            <p className="text-gray-700"><strong>Mail:</strong> Complaints Officer, [Your Business Address]</p>
            <p className="text-gray-700"><strong>Phone:</strong> [Your Phone Number]</p>
          </div>
          <p className="text-gray-700">
            We will acknowledge your complaint within 2 business days and aim to resolve it within 30 days. 
            We will keep you informed throughout the process.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">7.2 External Dispute Resolution</h3>
          <p className="text-gray-700 mb-4">
            If we are unable to resolve your complaint to your satisfaction, or you are not satisfied with 
            our response, you may refer the matter to an external dispute resolution service:
          </p>
          <div className="bg-gray-50 p-4 rounded-md">
            <p className="text-gray-700 mb-2"><strong>Australian Financial Complaints Authority (AFCA)</strong></p>
            <p className="text-gray-700">Website: www.afca.org.au</p>
            <p className="text-gray-700">Email: info@afca.org.au</p>
            <p className="text-gray-700">Phone: 1800 931 678</p>
            <p className="text-gray-700">Mail: GPO Box 3, Melbourne VIC 3001</p>
          </div>
          <p className="text-gray-700 mt-4">
            AFCA provides fair and independent financial services complaint resolution that is free to consumers.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Professional Indemnity Insurance</h2>
          <p className="text-gray-700">
            [TBC - Once obtained, include details of professional indemnity insurance coverage, including 
            policy number and coverage amount. Note: This may be required if you provide credit services 
            or financial advice in the future.]
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact Us</h2>
          <p className="text-gray-700 mb-4">
            If you have any questions about this Financial Services Guide or our services:
          </p>
          <div className="bg-gray-50 p-4 rounded-md">
            <p className="text-gray-700"><strong>Email:</strong> contact@loanloop.com.au</p>
            <p className="text-gray-700"><strong>Address:</strong> [Your Business Address]</p>
            <p className="text-gray-700"><strong>Phone:</strong> [Your Phone Number]</p>
            <p className="text-gray-700"><strong>Website:</strong> www.loanloop.com.au</p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Version Information</h2>
          <p className="text-gray-700">
            This is Version 1.0 of our Financial Services Guide, dated February 6, 2026.
          </p>
        </section>

        <div className="mt-8 p-6 bg-red-50 border-l-4 border-red-400">
          <p className="text-sm text-gray-700">
            <strong>LEGAL REVIEW REQUIRED:</strong> This document is a placeholder template only. 
            It must be reviewed, customized, and approved by a qualified legal professional before publication. 
            This FSG must comply with the Corporations Act 2001 (Cth) and ASIC regulations. Once you obtain 
            an Australian Credit Licence, this document will need to be updated accordingly.
          </p>
        </div>
      </div>
    </LegalPageLayout>
  )
}
